import { chakra } from "@chakra-ui/react";

const ChakraButton = chakra("button");

interface LinkTextProps {
  onClick?: () => void;
  children: React.ReactNode;
  fontSize?: string;
  color?: string;
}

export const LinkText = ({
  onClick,
  children,
  fontSize = "14px",
  color = "fg.brand",
}: LinkTextProps) => (
  <ChakraButton
    type="button"
    bg="transparent"
    border="0"
    p="0"
    cursor="pointer"
    fontFamily="body"
    fontSize={fontSize}
    fontWeight="semibold"
    color={color}
    textDecoration="none"
    _hover={{ textDecoration: "underline" }}
    onClick={onClick}
  >
    {children}
  </ChakraButton>
);
